namespace GeniuzPOS.Product {
    export interface CsArticleSeasonRow {
        Id?: number;
        ArticleSeasonCode?: string;
        ArticleSeasonName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsArticleSeasonRow {
        export const idProperty = 'ArticleSeasonCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsArticleSeason';
        export const lookupKey = 'Product.CsArticleSeason';

        export function getLookup(): Q.Lookup<CsArticleSeasonRow> {
            return Q.getLookup<CsArticleSeasonRow>('Product.CsArticleSeason');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ฤดูกาล:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ฤดูกาล:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ฤดูกาล:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:ฤดูกาล:Modify';

        export declare const enum Fields {
            Id = "Id",
            ArticleSeasonCode = "ArticleSeasonCode",
            ArticleSeasonName = "ArticleSeasonName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
